import { render } from "./titleHeader2.vue?vue&type=template&id=f60cf89a"
import script from "./titleHeader2.vue?vue&type=script&lang=js"
export * from "./titleHeader2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__